import type { SVGProps } from 'react';

export function FrenchFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 36 24"
      preserveAspectRatio="none"
      aria-hidden
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="12" height="24" fill="#002395" />
      <rect x="12" width="12" height="24" fill="#ffffff" />
      <rect x="24" width="12" height="24" fill="#ED2939" />
    </svg>
  );
}
